<template>
    <el-dropdown @command="handleCommand" class="dropdown">
        <el-button class="dropdown">
            {{ dropdown }}
            <img src="@/assets/images/bookIcons/downarrow.png" class="img">
        </el-button>
        <el-dropdown-menu slot="dropdown" class="dropdown-detail">
            <el-dropdown-item :command="item" v-for="(item,index) in selectList" :key="index">{{item}}</el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
export default {
  name: 'MySearchDropDown',
  props: {
    selectList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      dropdown: ''
    }
  },
  mounted () {
    this.dropdown = this.selectList[0]
  },
  methods: {
    handleCommand (command) {
      this.dropdown = command
    }
  }
}
</script>

<style scoped>
.dropdown {
    width: 165px;
    height: 40px;
    text-align: left;
}

.img {
    width: 15.76px;
    height: 15.76px;
    float: right;
}

.dropdown-detail {
    width: 165px;
}

.el-button:focus, .el-button:hover{
    color: #9E5C1D;
    background-color: #FFFFFF;
    border-color: #9E5C1D;
}
.el-dropdown:hover,.el-dropdown:focus{
    color: #9E5C1D;
    background-color: #FFFFFF;
    border-color: #ECDED1;
}
.dropdown-detail>>> .el-dropdown-menu__item:hover{
    color: #9E5C1D;
    background-color: #ECDED1;
    border-color: #9E5C1D;
}
</style>



// WEBPACK FOOTER //
// src/components/MySearchDropDown.vue